import React from 'react'
import './index.css'

function Boton() {
    return (
        <div className='boton'>
            <button>
                <span>Launch project</span>
            </button>
        </div>
    )
}

export default Boton